import React, { useState } from 'react';
import { compose } from 'redux';

import Form from '../MainForm';
import InputCheckbox from '../InputCheckbox';
import { Row } from '../../Structure';

import {
  withQualificationsActions,
  withScreenActions,
} from '../../../hocs/withActions';
import { withQualificationsData, withScreenData } from '../../../hocs/withData';
import InputTitle from '../InputTitle';

const OtherQualificationsForm = ({
  QualificationsData = {},
  SaveQualificationsForm = () => { },
  EnableSpinner = () => { },
}) => {
  const [values, setValues] = useState(QualificationsData);

  const handleSubmit = (event) => {
    event.preventDefault();
    const formattedValues = { ...values };
    EnableSpinner();
    SaveQualificationsForm({ ...formattedValues });
  };

  const updateChecked = (event) => {
    const { name, checked } = event;

    values[name] = checked;
    setValues({ ...values });
    // QualificationsFields({ ...values });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <InputTitle>
          CPCS Renewal Test passed or CPCS Renewal CPD course passed within 2
          years of the date of the application received*
        </InputTitle>
      </Row>
      <Row className="cpcs-test-passed">
        <InputCheckbox
          name="testPassed"
          onChange={updateChecked}
          required
          value="Yes"
          checked={values.testPassed}
        >
          Yes
        </InputCheckbox>
        <InputCheckbox
          name="testExempt"
          onChange={updateChecked}
          value="Exempt"
          checked={values.testExempt}
        >
          Exempt
        </InputCheckbox>
      </Row>
      <Row>
        <InputCheckbox
          name="hseQualification"
          onChange={updateChecked}
          required
          checked={values.hseQualification}
        >
          <strong>
            NOCN or CITB Health, safety and environment test (HS&E) passed within 2 years of the date of application received*
          </strong>
        </InputCheckbox>
      </Row>
      <Row>
        <InputCheckbox
          // true o false
          name="signedLogbook"
          onChange={updateChecked}
          required
          checked={values.signedLogbook}
        >
          <strong>
            I confirm I have a fully completed, signed logbook and/or will
            attach Competence Assessment Form for A61/A62/A68 for each category
            to be renewed.*
          </strong>
        </InputCheckbox>
      </Row>
      <Row>
        <InputCheckbox
          // true o false
          name="vqUnitsConforming"
          onChange={updateChecked}
          checked={values.vqUnitsConforming}
        >
          VQ Units Conforming to General Health, Safety and Welfare in the
          Workplace & Conforming to Productive Working Practices in the
          Workplace (Or the equivalent wording on your VQ cert relating to your
          Awarding Organisation)
        </InputCheckbox>
      </Row>
    </Form>
  );
};

export default compose(
  withQualificationsActions,
  withQualificationsData,
  withScreenData,
  withScreenActions
)(OtherQualificationsForm);
